// Every localStorage/sessionStorage access in the app goes through here.
// Reading `window.localStorage` raises a SecurityError when the browser is set
// to block site data (Chrome "Don't allow sites to save data on your device",
// a sandboxed iframe, some managed profiles), and several of these reads happen
// in App.vue's `beforeMount`, where a throw aborts the very first render and
// leaves a blank page. Writes can also throw once the quota is exhausted.

function resolve(name) {
  try {
    return window[name] || null;
  } catch (error) {
    return null;
  }
}

const local = resolve('localStorage');
const session = resolve('sessionStorage');

export function getItem(key) {
  try {
    return local ? local.getItem(key) : null;
  } catch (error) {
    return null;
  }
}

export function setItem(key, value) {
  try {
    if (local) {
      local.setItem(key, value);
    }
  } catch (error) {
    // Storage unavailable: the value simply does not persist.
  }
}

export function removeItem(key) {
  try {
    if (local) {
      local.removeItem(key);
    }
  } catch (error) {
    // Nothing to remove if storage cannot be reached.
  }
}

// Returns [storage, keys] pairs so callers can iterate both storages at once.
export function allStorageKeys() {
  return [local, session].filter(Boolean).map(storage => {
    try {
      return [storage, Object.keys(storage)];
    } catch (error) {
      return [storage, []];
    }
  });
}
